import React from 'react';

import { MODAL_TYPES } from 'Feature/components/app-modals';
import MoldReleaseAddEdit from './mold-release-add-edit';

const { MOLDRELEASE_ADD_EDIT } = MODAL_TYPES;

const MoldReleaseModals = () => {
  return (
      <>
         <MoldReleaseAddEdit modalId={MOLDRELEASE_ADD_EDIT} />
        
       </>
     );
   };
   

export default MoldReleaseModals